module.exports = __webpack_public_path__ + "dlssrvtyy/img/thai_slider-4.jpg?d77b1128";